import React from "react";
import { Button } from "antd";
// import { WhatsApp } from "@mui/icons-material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
const ContactChat = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <Button
        type="primary"
        className="scroll-to-top-button"
        onClick={() => window.open("http://wa.me/447564627910", "_blank")} // Replace with your Messenger username
      >
        <WhatsAppIcon className="messenger-icon" fontSize="large" />
      </Button>
    </div>
  );
};

export default ContactChat;
